module.exports = __webpack_public_path__ + "img/mao.6f3f2fe7.jpg";